export default __webpack_public_path__ + "static/15_23-d4e9cb97bbd5aee0e0eb9b009ecd961f.png";